'use strict';

import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/ui/i18n/datepicker-ru";
import "jquery-ui/ui/i18n/datepicker-uk";
import "./../lib/jquery.datepicker.extension.range.min";

(function($){


    function init() {
        var date_btn = document.querySelector('.data-period');

        if(!date_btn){
            return;
        }

        $('#date_range').datepicker({
            range: 'period', // режим - выбор периода
            numberOfMonths: document.documentElement.clientWidth > 600 ? 2 : 1,
            // numberOfMonths: 1, // 600 px
            onSelect: function(dateText, inst, extensionRange) {
                // extensionRange - объект расширения
                $('[name=startDate]').val(extensionRange.startDateText);
                $('[name=endDate]').val(extensionRange.endDateText);
            },
            maxDate: -1,
            showOtherMonths: true,
            selectOtherMonths: true,

        });

        // var today = new Date();

        $('#date_range').datepicker('option', $.datepicker.regional[document.documentElement.lang]);
        // $('#date_range').datepicker('setDate', ['-3m', '-1d']);
        // $('#date_range').datepicker('setDate', [new Date(today.getFullYear(), today.getMonth(), 1), '-1d']);
        initialCalendarData();

        // объект расширения (хранит состояние календаря)
        var extensionRange = $('#date_range').datepicker('widget').data('datepickerExtensionRange');
        if(extensionRange.startDateText) $('[name=startDate]').val(extensionRange.startDateText);
        if(extensionRange.endDateText) $('[name=endDate]').val(extensionRange.endDateText);


        date_btn.addEventListener('click', function(){
            // data-period
            if(date_btn.classList.contains('data-period_active')) {
                date_btn.classList.remove('data-period_active');
            } else {
                date_btn.classList.add('data-period_active');
            }
        });

    }

    function initialCalendarData(){
        const inputStart = $('[name=startDate]'),
            inputEnd = $('[name=endDate]'),
            today = new Date();

        if ( inputStart.val().length && inputEnd.val().length ) {
            $('#date_range').datepicker('setDate', [inputStart.val(), inputEnd.val()]);
        } else {
            $('#date_range').datepicker('setDate', [new Date(today.getFullYear(), today.getMonth(), 1), '-1d']);
        }
    }

    $(document).mouseup(function (e){ // событие клика по веб-документу
        let div = $(".prfl-dataset_datepicker"); // тут указываем ID элемента
        if (!div.is(e.target) // если клик был не по нашему блоку
            && div.has(e.target).length === 0) { // и не по его дочерним элементам
            div.find(".data-period").removeClass("data-period_active"); // скрываем его
        }
    });

    document.addEventListener('DOMContentLoaded', init)

}(jQuery));
